import React, { useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Confirm invite-and-mention before adding a non-participant.
 */
export default function InviteAndMentionDialog({
  open,
  onOpenChange,
  displayName,
  mode = "invite",
  loading = false,
  error = null,
  onConfirm,
}) {
  const confirmRef = useRef(null);
  const name = displayName || "this person";
  const title =
    mode === "create-group" ? "Create group and mention?" : "Invite and mention?";
  const description =
    mode === "create-group"
      ? `This will create a new group chat with ${name} (and keep your current DM unchanged), then insert the mention into your draft.`
      : `Add ${name} to this conversation and insert a mention? They will become a participant.`;
  const confirmLabel =
    mode === "create-group" ? "Create group" : "Invite and mention";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-md"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          confirmRef.current?.focus();
        }}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {error ? (
          <p className="text-sm text-destructive" role="alert">
            {error}
          </p>
        ) : null}
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="ghost"
            disabled={loading}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            ref={confirmRef}
            type="button"
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? "Working…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
